
import React from 'react';
import api from './api';
import './Doctors.css';
import { FaEdit, FaPlus, FaTrash } from "react-icons/fa";
//import MDButton from './MDButton';
import {Link} from "react-router-dom"
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
//import "./styles.css";

import useAuth from "../hooks/useAuth";
import { canDo } from '../utils/canDo';
import {
    useState,
    useEffect
} from 'react';
import CustomDataTable from './CustomDataTable';

const Recomms = ({patientCard}) => {
  const { auth } = useAuth();
  const [recomms, setRecomms] = useState([]);
  const [isEditMode, setIsEditMode] = useState(true);
  
  const [newRecomm, setNewRecomm] = useState({ recommendation: '', qty: 0, not:0, nod:0, remarks: "" });
  const [selectedRecomm, setSelectedRecomm] = useState(null);
  const [isRebirthChecked, setRebirth] = useState(false);
  var modExers =[];
   // const [isEditMode, setIsEditMode] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  useEffect(() => {
        getRecomms()  
   }, []);

 
  const getRecomms = 
      () => {
       var ur = "recommendations";
        if (patientCard)
        {
             ur = `patients/consultation/${patientCard}`
        }
    
     api.get(`${process.env.REACT_APP_URL}/${ur}`)
      //api.get(`${process.env.REACT_APP_URL}/recommendations`)
      .then(response => { 

          var recs = response.data;
          console.log("recs patientCard",recs, patientCard);
          if (patientCard)
            setRecomms(recs.recommendations);
          else
            setRecomms(recs)
       })
      .catch(error =>
          console.error('Error fetching Recomms:', error));
      }

      
  const columns = [
    {
        name: "Recommendation",
        sortable: true,
        selector: (row) => row?.recommendation,
    },
    {
      name: "Quantity",
      selector: (row) => row.qty,
      sortable: true,
    
    },
    {
      name: "No. of Days",
      selector: (row) => row?.nod,
      sortable: true,
    
    },
    {
      name: "No. Of Time",
      selector: (row) => row?.not,
      sortable: true,
    
    },
     {
      name: "Type",
      selector: (row) => row?.rtype,
      sortable: true,
    },
    /*
    {
      name: "StartDate",
      selector: (row) => row?.startDate,
    },*/
    {
      name: "Remarks",
      selector: (row) => row?.remarks,
      width: "120px",
      wrap: true,
    
    },
         {
                name: "Actions",
                sortable: false,
                omit:  !canDo(auth, 'recommendations.edit') && !canDo(auth, 'recommendations.add'),
                cell: (row) =>
                       (                       
                           <>
                              <div style={{ display: 'flex', gap: '30px', alignItems: 'center' }}>
  
                               <div className="task-icon">

                                 <FaEdit onClick={updateExer.bind(this,row?._id)}
                                    size={18} // Adjust size as needed
                                    style={{ cursor: 'pointer', color: 'green'}}
                                />
                               </div>
                             
                             {!canDo(auth, 'recommendations.edit') ? (
                               // Empty fragment or no action for role "s"
                               <></>
                             ) : (
                               <div className="task-icon">
                                 <FaTrash onClick={handleDeleteRec.bind(this,row?._id)} 
                                    size={18} // Adjust size as needed
                                    style={{ cursor: 'pointer', color: 'red'}}
                                    />
                               </div>
                             )}   
                             </div>
                           </>
                         )
                   }, 
  ];
    
        //const data = patients;
        const tableData = {
          columns:columns,
          data:recomms
        };
 
  
        const handleAddExer =
        (e) => {
            e.preventDefault();

            api.post(
            `${process.env.REACT_APP_URL}/recommendations/add`, newRecomm)
                .then(response => {
                    //console.log(response.data);
                    setRecomms([...recomms, response.data]);
                    setNewRecomm({});// name: '', age: '', gender: '' });
                    handleClose();
                })
                .catch(error =>
                    console.error('Error adding user:', error));
        };

        
    const handleUpdateRecommendation =
        (id, e) => {
            e.preventDefault();

            api.post(
              `${process.env.REACT_APP_URL}/recommendations/update/${id}`, selectedRecomm)
                .then(response => {
                    const updatePat = {
                        ...selectedRecomm,
                        _id: id
                    };
              //console.log(response.data);
                   // setRecomms([...recomms, response.data]);
                   // setNewRecomm({});// name: '', age: '', gender: '' });
                    handleClose();
                })
                .catch(
                    error => {
                        console.error('Error updating recommendation:', error);
                        alert("Error updating Recommendation. Please try again!");
                });
        };

      const handleDeleteRec = (id) => {
        var ret = window.confirm("Are you sure you want to delete this ?");
        if (! ret)
          return;
        //confirm("Are you sure you want to delete this entry ?");
        api.delete(`${process.env.REACT_APP_URL}/recommendations/delete/${id}`)
              .then(response => {
                  //console.log(response.data);
                  setSelectedRecomm(null);
                  handleClose();
              })
              .catch(
                  error =>{
                    console.error('Error deleting recommendation:', error);
                    alert("Error deleting Recommendation. Please try again!");
            });
      };


const handleClose = () => {
  setIsModalOpen(false);
 // setSelectedRecommendation(null);
  setIsEditMode(false);
  getRecomms();
  //setModalChanged(false);
  //setModalData(null);
 // getRecommendations();
}

const addNewExers = (e) => {
  e.preventDefault();

  setSelectedRecomm(null);
  setIsEditMode(false); // Switch to Add mode
  setIsModalOpen(true);
  //setModalChanged(false);
  //setModalData(null);
}

const updateExer = (id) => {

    var p = recomms.find(
    (patient) => {
    return (patient._id === id )
  });
  setSelectedRecomm(p);
  setIsModalOpen(true);
  setIsEditMode(true); // Switch to Edit mode
}
    const handleDeleteRecomm =
      (id) => {
        setSelectedRecomm(null);
        setIsModalOpen(false);
        setIsEditMode(false);
          //confirm("Are you sure you want to delete this entry ?");
          api.delete(`${process.env.REACT_APP_URL}/recommendations/${id}`)
              .then(response => {
                  //console.log(response.data);
                  setSelectedRecomm(null);
                  handleClose();
              })
              .catch(
                  error =>
                      console.error('Error deleting recomm:', error));
      };
  
//const prefilledSelectionCriteria = row => (row.parentId && row.parentId != "");
  return (
    <div>
    {isModalOpen ? (
      <div>
           <div className='tableheaderActions'>
      
           <button id="cnew" type="button" className='btn btn-outline-primary' aria-label='Add New'
           onClick={handleClose}
           > Close</button>
         </div>
      
      <div className='patient-main  '>
            <div className='form-sections  '>
                <h4>
                    {
                        isEditMode ?
                            'Edit Recomm' :
                            'Add New Recomm'
                    }
                </h4>
                <form onSubmit=
                    {
                        isEditMode ?
                            (e) =>
                                handleUpdateRecommendation(selectedRecomm._id, e) :
                            handleAddExer}>
                              
                              <div className='ele'>
                                  <label>Name: </label>
                                  <input type="text"
                                      value=
                                      {
                                          isEditMode ?
                                              selectedRecomm?.recommendation : newRecomm?.recommendation
                                      }
                                      onChange={
                                          (e) =>
                                              isEditMode ?
                                                  setSelectedRecomm(
                                                      {
                                                          ...selectedRecomm,
                                                          recommendation: e.target.value
                                                      }) :
                                                  setNewRecomm(
                                                      {
                                                          ...newRecomm,
                                                          recommendation: e.target.value
                                                      }
                                                  )} />
                                  <br />
                               
                                  <label>Qty: </label>
                                  <input type="text"
                                      value=
                                      {
                                          isEditMode ?
                                              selectedRecomm?.qty : newRecomm?.qty
                                      }
                                      onChange={
                                          (e) =>
                                              isEditMode ?
                                                  setSelectedRecomm(
                                                      {
                                                          ...selectedRecomm,
                                                          qty: e.target.value
                                                      }) :
                                                  setNewRecomm(
                                                      {
                                                          ...newRecomm,
                                                          qty: e.target.value
                                                      }
                                                  )} />
                                  <br />
                                  </div>
                    
                              <div className='ele'>
                                  <label>Type ( Drink / Eat / Therapy /etc): </label>
                                  <input type="text"
                                      value=
                                      {
                                          isEditMode ?
                                              selectedRecomm?.rtype : newRecomm?.rtype
                                      }
                                      onChange={
                                          (e) =>
                                              isEditMode ?
                                                  setSelectedRecomm(
                                                      {
                                                          ...selectedRecomm,
                                                          rtype: e.target.value
                                                      }) :
                                                  setNewRecomm(
                                                      {
                                                          ...newRecomm,
                                                          rtype: e.target.value
                                                      }
                                                  )} />
                                  <br />
                               
                                  <label>Remarks: </label>
                                  <input type="text"
                                      value=
                                      {
                                          isEditMode ?
                                              selectedRecomm?.remarks : newRecomm?.remarks
                                      }
                                      onChange={
                                          (e) =>
                                              isEditMode ?
                                                  setSelectedRecomm(
                                                      {
                                                          ...selectedRecomm,
                                                          remarks: e.target.value
                                                      }) :
                                                  setNewRecomm(
                                                      {
                                                          ...newRecomm,
                                                          remarks: e.target.value
                                                      }
                                                  )} />
                                  <br />
                                  </div>
                                 <div className='ele'>
                                  <label> Number of Times a Day </label>
                                  <input type="text"
                                      value=
                                      {
                                          isEditMode ?
                                              selectedRecomm?.not : newRecomm?.not
                                      }
                                      onChange={
                                          (e) =>
                                              isEditMode ?
                                                  setSelectedRecomm(
                                                      {
                                                          ...selectedRecomm,
                                                          not: e.target.value
                                                      }) :
                                                  setNewRecomm(
                                                      {
                                                          ...newRecomm,
                                                          not: e.target.value
                                                      }
                                                  )} />
                                  <br />
                               
                                  <label>Number of Days: </label>
                                  <input type="text"
                                      value=
                                      {
                                          isEditMode ?
                                              selectedRecomm?.nod : newRecomm?.nod
                                      }
                                      onChange={
                                          (e) =>
                                              isEditMode ?
                                                  setSelectedRecomm(
                                                      {
                                                          ...selectedRecomm,
                                                          nod: e.target.value
                                                      }) :
                                                  setNewRecomm(
                                                      {
                                                          ...newRecomm,
                                                          nod: e.target.value
                                                      }
                                                  )} />
                                  <br />
                                  
                          
                                  <button type="submit">
                                      {
                                          isEditMode ?
                                              'Update Recomm' :
                                              'Add Recomm'
                                      }
                                  </button>
                                  </div>
                </form>
            </div>
      </div>
      </div>           
      ):
   
      <div>
        { auth.roles && auth.roles.indexOf("therapist") != -1 ? 
            <div> 
       <CustomDataTable columns={columns} data={recomms} 
        //selectableRows 
        pagination
        highlightOnHover	
        header="Table header"
        striped	
        responsive
        pointerOnHover	
        dense	
        paginationPerPage={100} 
   persistTableHead	
        fixedHeader	
        fixedHeaderScrollHeight='300px' 
        //progressPending	recomms
        defaultSortField="id"
        defaultSortAsc={true}
        direction
      
        />
        </div>
        : 
        <div>
        <div className='tableheaderActions'>
      
          <button id="cnew" type="button" className='btn btn-outline-primary' aria-label='Add New'
            onClick={addNewExers}
          > Add New</button>

        </div>
     
        
        <CustomDataTable columns={columns} data={recomms} 
        //selectableRows 
        pagination
        highlightOnHover	
        header="Table header"
        striped	
        responsive
        pointerOnHover	
        dense	
        paginationPerPage={100} 
        persistTableHead	
        fixedHeader	
        fixedHeaderScrollHeight='300px' 
        //progressPending	recomms
        defaultSortField="id"
        defaultSortAsc={true}
        direction
      
        />
      
      
      </div>
       }
       </div> 
    }
   </div>
  );

}
export const checkboxesList = [
  'mon',
  'tues',
  'wed',
  'thurs',
  'fri',
  'sat',
  'sun',
];



export default Recomms;